import request from '@/utils/request'

// 全部红旗列表
export function flagList(query) {
  return request({
    url: '/dianjiang/orderMarkSet/listDate',
    method: 'get',
    params: query
  })
}

// 全部工单列表
export function getList(query) {
  return request({
    url: '/order/findOrderPage',
    method: 'get',
    params: query
  })
}
// 全部历史工单列表
export function getHistoryList(query) {
  return request({
    url: '/order/findOrderHistoryPage',
    method: 'get',
    params: query
  })
}

// 工单详情
export function getDetail(query) {
  return request({
    url: '/order/orderForm',
    method: 'get',
    params: query
  })
}

// 历史工单详情
export function getHisDetail(query) {
  return request({
    url: '/order/HIstoryOrderForm',
    method: 'get',
    params: query
  })
}

// 工单详情
export function etOrderNeedReturnFitting(query) {
  return request({
    url: '/order/order-callback/getOrderNeedReturnFitting',
    method: 'get',
    params: query
  })
}


// 标记工单类型
export function saveFlagOrder(query) {
  return request({
    url: '/order/flagOrder',
    method: 'get',
    params: query
  })
}

// 工单加急下拉
export function urgentList() {
  return request({
    url: '/dianjiang/orderSetting/listDate',
    method: 'get',
  })
}

// 删除反馈记录
export function deleteBack(query) {
  return request({
    url: '/order/order-feedback/deleteBack',
    method: 'get',
    params: query
  })
}

// 获取服务商收货地址
export function getSiteReceive(query) {
  return request({
    url: '/receive/getSiteReceive',
    method: 'get',
    params: query
  })
}

// 全部工单数据导出
export function exportList(query) {
  return request({
    url: '/order/export',
    method: 'get',
    params: query
  })
}

// 工单申请备件
export function addOrderFitting(data) {
  return request({
    url: '/fitting/factory-fitting-apply/addOrderFitting',
    method: 'POST',
    data: data
  })
}

// 一键复制重新申请
export function copyApplyFitting(data) {
  return request({
    url: '/fitting/factory-fitting-apply/copyApplyFitting',
    method: 'POST',
    params: data
  })
}

// 平台个人记录
export function getFollowUp(data) {
  return request({
    url: '/order/FollowUp',
    method: 'get',
    params: data
  })
}

// 删除平台个人记录
export function deleteFollowUp(query) {
  return request({
    url: '/order/deleteFollowUp',
    method: 'get',
    params: query
  })
}

// 工单详情里面的服务要求
export function getByProductLineName(data) {
  return request({
    url: '/orderCommon/getByProductLineName',
    method: 'get',
    params: data
  })
}

// 无效类型
export function getInvalidReasonSelect() {
  return request({
    url: '/orderCommon/invalidReasonSelect',
    method: 'get',
  })
}

// 工单详情里面的服务要求
export function invalidOrder(data) {
  return request({
    url: '/factoryOrder/invalidOrder',
    method: 'POST',
    data: data
  })
}

// 修改工单
export function editSave(data) {
  return request({
    url: '/factoryOrder/editOrder',
    method: 'POST',
    data: data
  })
}

// 派工获取服务商
export function findOrderSiteList(data) {
  return request({
    url: '/order/order-dispatch/findOrderSiteList',
    method: 'Get',
    params: data
  })
}

// 确认派工
export function dispatchOrderSite(data) {
  return request({
    url: '/order/order-dispatch/dispatchOrderSite',
    method: 'Get',
    params: data
  })
}

// 确认转派
export function turnDispatchOrderSite(data) {
  return request({
    url: '/order/order-dispatch/turnDispatchOrderSite',
    method: 'Get',
    params: data
  })
}

// 根据服务类型获取服务措施
export function getMeasuresByServiceType(data) {
  return request({
    url: '/serviceMeasure/getMeasuresByServiceType',
    method: 'Get',
    params: data
  })
}
// 服务完成
export function feedbackSealingSheet(data) {
  return request({
    url: '/order/order-feedback/feedbackSealingSheet',
    method: 'Get',
    params: data
  })
}
// 过程反馈
export function processFeedback(data) {
  return request({
    url: '/order/order-feedback/processFeedback',
    method: 'Get',
    params: data
  })
}

// 重新反馈封单-只有待回访状态下才可以操作
export function againFeedbackSealingSheet(data) {
  return request({
    url: '/order/order-feedback/againFeedbackSealingSheet',
    method: 'Get',
    params: data
  })
}

// 反馈完成-已完成工单状态下才可以操作
export function feedbackSealingSheetYwc(data) {
  return request({
    url: '/order/order-feedback/feedbackSealingSheetYwc',
    method: 'Get',
    params: data
  })
}

// 完工时长、里程距离以及里程费用
export function getOrderSiteSett(data) {
  return request({
    url: '/order/order-site-settlement/getOrderSiteSett',
    method: 'Get',
    params: data
  })
}

// 修改里程
export function updateOrderMileage(data) {
  return request({
    url: '/order/updateOrderMileage',
    method: 'Get',
    params: data
  })
}

// 保存回访信息
export function saveCallback(data) {
  return request({
    url: '/order/order-callback/saveCallback',
    method: 'Get',
    params: data
  })
}

// 保存回访--审核
export function saveAuditResult(data) {
  return request({
    url: '/order/orderFeeApplication/saveAuditResult',
    method: 'post',
    data: data
  })
}

// 保存重新回访信息
export function anewCallbackUpdate(data) {
  return request({
    url: '/order/order-callback/anewCallbackUpdate',
    method: 'Get',
    params: data
  })
}

// 判断工单配件需要返厂的是否已经返厂
export function getOrderFittingCount(data) {
  return request({
    url: '/order/order-callback/getOrderFittingCount',
    method: 'Get',
    params: data
  })
}
//工单回访
// 获取结算方案详细信息
export function calllBackgetByNumber(data) {
  return request({
    url: '/order/order-callback/getTemplateByNumber',
    method: 'POST',
    params: data
  })
}

// 品牌商结算方案
export function getFactorySettlementTemplate(data) {
  return request({
    url: '/order/order-callback/getFactorySettlementTemplate',
    method: 'POST',
    params: data
  })
}


// 根据服务措施-品牌商结算方案
export function getFactorySettlementByStep(data) {
  return request({
    url: '/order/order-callback/getFactorySettlementByStep',
    method: 'POST',
    params: data
  })
}


//获取结算方案
export function getSiteServiceMeasuresByStep(data) {
  return request({
    url: '/order/order-site-settlement/getSiteServiceMeasuresByStep',
    method: 'Get',
    params: data
  })
}

// 获取品牌、服务措施结算方案
export function getSiteServiceMeasuresByCate(data) {
  return request({
    url: '/order/order-site-settlement/getSiteServiceMeasuresByCate',
    method: 'GET',
    params: data
  })
}

//工单服务商结算管理
// 获取结算方案详细信息
export function getSiteTemplateByNumber(data) {
  return request({
    url: '/order/order-site-settlement/getSiteTemplateByNumber',
    method: 'POST',
    params: data
  })
}

//保存服务商结算
export function saveSettlementOrder(data) {
  return request({
    url: '/order/order-site-settlement/saveSettlementOrder',
    method: 'GET',
    params: data
  })
}

// 保存服务商重新结算
export function saveAgainSettlementOrder(data) {
  return request({
    url: '/order/order-site-settlement/saveAgainSettlementOrder',
    method: 'GET',
    params: data
  })
}
// 查看上一次结算信息
export function getLastTimeSettle(query) {
  return request({
    url: '/order/getLastTimeSettle',
    method: 'get',
    params: query
  })
}

// 保存品牌重新结算
export function saveAgainFacSettlementOrder(data) {
  return request({
    url: '/order/order-factory-settlement/saveAgainFacSettlementOrder',
    method: 'Get',
    params: data
  })
}

// 登记工单列表
export function registerOrderPageList(data) {
  return request({
    url: '/order/registerOrderPage',
    method: 'Get',
    params: data
  })
}

// 拒单
export function rejectionOrderjd(data) {
  return request({
    url: '/order/rejectionOrder',
    method: 'Get',
    params: data
  })
}

// 服务商服务中
export function getInServiceOrderStatic(data) {
  return request({
    url: '/order/getInServiceOrderStatic',
    method: 'Get',
    params: data
  })
}

// 品牌商服务中
export function getInServiceFactoryStatic(data) {
  return request({
    url: '/order/getInServiceFactoryStatic',
    method: 'Get',
    params: data
  })
}

// 备件单工单列表
export function platformFittingOrderPage(data) {
  return request({
    url: '/order/platformFittingOrderPage',
    method: 'Get',
    params: data
  })
}

// 待派单=1、服务中=2、待回访=3、服务商待结算=4、已完成=5、无效=6工单列表(status 必填)
export function getPlatformOrderStatus(data) {
  return request({
    url: '/order/getPlatformOrderStatus',
    method: 'Get',
    params: data
  })
}

// 投诉单工单列表
export function platformCompFlagOrderPage(data) {
  return request({
    url: '/order/platformCompFlagOrderPage',
    method: 'Get',
    params: data
  })
}

// 服务中催单
export function reminderOrder(data) {
  return request({
    url: '/order/reminderOrder',
    method: 'Get',
    params: data
  })
}

// 更新签收时间（只有工单有备件的时候按钮才显示）
export function updateSignForTime(data) {
  return request({
    url: '/order/updateSignForTime',
    method: 'Get',
    params: data
  })
}

// 服务商服务中-导出
export function getInServiceOrderExcel(data) {
  return request({
    url: '/order/getInServiceOrderExcel',
    method: 'Get',
    params: data
  })
}

// 导出投诉单工单列表
export function exportPlatformCompFlagOrders(data) {
  return request({
    url: '/order/exportPlatformCompFlagOrder',
    method: 'Get',
    params: data
  })
}
// 获取客服电话
export function getCustomerServiceMobile(data) {
  return request({
    url: '/platform/sended-sms/getCustomerServiceMobile',
    method: 'Get',
  })
}

// 发送短信
export function getSendmsgModel(data) {
  return request({
    url: '/platform/sended-sms/getSendmsgModel',
    method: 'Get',
    params: data
  })
}

// 最新反馈内容
export function getFeedbackList(data) {
  return request({
    url: '/order/getFeedbackList',
    method: 'Get',
    params: data
  })
}
// 最新反馈内容
export function getOrderByThreeMonth(data) {
  return request({
    url: '/order/order-dispatch/getOrderByThreeMonth',
    method: 'Get',
    params: data
  })
}

// 修改反馈
export function getfeedback(query) {
  return request({
    url: '/order/order-feedback/editFeedback',
    method: 'get',
    params: query
  })
}

// 设置工单置顶/取消置顶
export function setIfTop(query) {
  return request({
    url: '/order/setIfTop',
    method: 'get',
    params: query
  })
}


// 信息员服务中
export function getEmpInServiceOrderStatic(query) {
  return request({
    url: '/order/getEmpInServiceOrderStatic',
    method: 'get',
    params: query
  })
}

//修改服务类型
export function editServiceType(query) {
  return request({
    url: '/factoryOrder/editServiceType',
    method: 'get',
    params: query
  })
}

// 催单未回
export function signReminderNot(query) {
  return request({
    url: '/order/signReminderNot',
    method: 'get',
    params: query
  })
}

// 今日工单
export function lookInServiceOrderStatic(data) {
  return request({
    url: '/order/lookInServiceOrderStatic',
    method: 'post',
    data: data
  })
}

// 网点待回访
export function visitOrderSiteStatic(query) {
  return request({
    url: '/order/visitOrderSiteStatic',
    method: 'get',
    params: query
  })
}

// 厂家待回访
export function visitOrderFittingFactoryStatic(query) {
  return request({
    url: '/order/visitOrderFittingFactoryStatic',
    method: 'get',
    params: query
  })
}

// 厂家查看
export function lookVisitOrderFittingStatic(data) {
  return request({
    url: '/order/lookVisitOrderFittingStatic',
    method: 'post',
    data: data
  })
}


// 信息员--待回访 --列表数据
export function empVisitOrderStatic(query) {
  return request({
    url: '/order/empVisitOrderStatic',
    method: 'get',
    params: query
  })
}

// 信息员--查看备件统计信息
export function empVisitOrderFittingStatic(data) {
  return request({
    url: '/order/empVisitOrderFittingStatic',
    method: 'post',
    data: data
  })
}

// 第三方工单
export function findTransferOrderPage(data) {
  return request({
    url: '/order/findTransferOrderPage',
    method: 'Get',
    params: data
  })
}

// 标记异常
export function tageAbnormalFitting(query) {
  return request({
    url: '/order/tageAbnormalFitting',
    method: 'get',
    params: query
  })
}

// 退出异常
export function exitAbnormalRecord(query) {
  return request({
    url: '/order/exitAbnormalRecord',
    method: 'get',
    params: query
  })
}

// 处理异常
export function handleAbnormalFitting(query) {
  return request({
    url: '/order/handleAbnormalFitting',
    method: 'get',
    params: query
  })
}
//挂起
export function suspendOrderGq(query){
  return request({
    url: '/order/suspendOrder',
    method: 'get',
    params: query
  })
}

//取消挂起
export function transferOutOrder(query){
  return request({
    url: '/order/transferOutOrder',
    method: 'get',
    params: query
  })
}



// 厂家催单列表
export function platformFittingOrder(query) {
  return request({
    url: '/order/platformFittingOrderPage',
    method: 'get',
    params: query
  })
}

// 费用信息
export function feeApplicationMsgs(query) {
  return request({
    url: '/order/orderFeeApplication/feeApplicationMsgs',
    method: 'get',
    params: query
  })
}

// 信息员--服务中--今日工单
export function getEmpInServiceOrderStatic2(query) {
  return request({
    url: '/order/getEmpInServiceOrderStatic2',
    method: 'post',
    data: query
  })
}

// 平台派单给网点的时候，根据详细地址获取周边用户信息
export function getAroundCustomerInfo(query) {
  return request({
    url: '/order/order-dispatch/getAroundCustomerInfo',
    method: 'get',
    params: query
  })
}

// 删除反馈中的图片
export function delFeedImg(query) {
  return request({
    url: '/order/order-feedback/deleteFeedbackImg',
    method: 'get',
    params: query
  })
}

